import React from "react";
import ProyectoAPI from "../../api/proyectos-api";
import { Messages } from "../../helpers/message-helper";
import Fa from "../common/Fa";
import PlanoAPI from "../../api/plano-api";
import Table from "../common/Table";

/**
 *
 */
export default class PlanoList extends React.Component {
  /**
   * Se encarga de recuperar la lista de las columnas de grilla.
   */
  columns = [
      { key: "id", title: "#", isKey: true },
      { key: "tipo", title: "tipo", isKey: false },
      { key: "mz_agr", title: "Manzana", isKey: false },
      { key: "lote_agr", title: "Lote", isKey: false },
      { key: "sup_legal", title: "Sup Legal", isKey: false }
];
  /**
   * Se encarga de renderizar la grilla.
   */
  render() {
    return (
      <React.Fragment>
        <Table
          api={PlanoAPI}
          onRef={ref => (this.table = ref)}
          columns={this.columns}
          filters={this.props.filters}
          pagination={true}
        />
        <br/>
      </React.Fragment>
    );
  }
}
